<template>
  <div class="services-details-bg pt-120 pb-100">
    <div class="container">
      <!-- Images: Side-by-Side -->
      <div class="services-details-img d-flex gap-3 mb-4 flex-wrap justify-content-end">
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/ser1.jpg"
          alt="services-details"
          class="top-banner-img"
        />
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/sera1.jpg"
          alt="services-details"
          class="top-banner-img"
        />
      </div>

      <!-- Content and Sidebar -->
      <div class="row">
        <div class="col-lg-8">
          <div class="services-details-content pt-4">
            <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Celebrity Promotions & Influencer Marketing</h2>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Build Trust. Drive Buzz. Get Results.</h3>
            <p>
              At <strong>MyCelebrity</strong>, we connect brands with
              <strong>India’s top celebrities and influencers</strong> to deliver
              campaigns that captivate audiences and create
              <strong>instant brand credibility</strong>. Whether it's a product launch,
              festive promo, or long-term brand ambassadorship — we handle everything
              from ideation to execution.
            </p>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">What We Offer:</h3>
            <ul>
              <li>Celebrity Endorsements (TV, Print, Digital)</li>
              <li>Influencer Campaigns (Regional, National, Micro & Macro Influencers)</li>
              <li>Reels, Story & UGC Campaigns</li>
              <li>Festive & Topical Campaign Strategy</li>
              <li>Talent Sourcing, Negotiation & Onboarding</li>
              <li>Content Planning, Shoot Coordination & Distribution</li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Brands We've Worked With:</h3>
            <ul>
              <li><b>Sunpure</b> – Celebrity-driven festive campaigns that brought traditional purity to the modern kitchen.</li>
              <li><b>Ramraj Cotton</b> – Styled by stars for Pongal and festive collections.</li>
              <li><b>Man Matters & Be Bodywise</b> – Male grooming & wellness influencers for performance-driven campaigns.</li>
              <li><b>Little Joys</b> – Real mom influencers building organic trust.</li>
              <li><b>Jos Alukkas</b> – Celebrity campaign for premium jewelry collection.</li>
              <li><b>Harpik & Everest Masala</b> – Home care & spice giants leveraging national influencer chains.</li>
              <li><b>Lulu Mall, Godesi, Casagrande, Wysh, Dewar’s, Hatsun, Arun Ice Cream, Instapure, Intralife</b> – from fashion to FMCG, real estate to healthcare — our influencer network delivers across sectors.</li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Why It Works:</h3>
            <ul>
              <li>Authentic endorsements from trusted voices</li>
              <li>Boosted engagement, reach, and conversions</li>
              <li>Story-driven content tailored to your audience</li>
              <li>End-to-end execution with legal and creative compliance</li>
            </ul>
          </div>
        </div>

        <div class="col-lg-4 mt-4 mt-lg-0">
          <ServicesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServicesSidebar from "@/components/ServiceDetails/ServivesSidebar.vue";

export default {
  name: "ServicesDetails",
  components: {
    ServicesSidebar,
  },
};
</script>

<style lang="scss" scoped>
.services-details-bg {
  padding-top: 180px;
  padding-bottom: 100px;
  transition: background-color 0.3s ease;
}

// Light mode (default)
:deep(body):not(.theme-dark) {
  .services-details-bg {
    background-color: #fff;
    color: #000;
  }
}

// Dark mode
:deep(body.theme-dark) {
  .services-details-bg {
    background-color: #111;
    color: #fff;
  }
}

.services-details-img {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-end;

  .top-banner-img {
    width: 48%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 20px;
    display: block;
  }
}

.services-details-content {
  padding-top: 20px;

  h2 {
    font-size: 36px;
    margin-bottom: 25px;
  }

  h3 {
    font-family: var(--bodyFontFamily);
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 1.2rem;
    margin-bottom: 20px;

    li {
      margin-bottom: 10px;
    }
  }
}

/* Responsive */
@media only screen and (max-width: 767px) {
  .services-details-img {
    flex-direction: column;
    align-items: center;

    .top-banner-img {
      width: 100%;
      max-height: 220px;
    }
  }

  .services-details-content h2 {
    font-size: 25px;
    margin-bottom: 15px;
  }

  .col-lg-4 {
    margin-top: 30px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-details-img .top-banner-img {
    max-height: 300px;
  }

  .services-details-content h2 {
    font-size: 30px;
    margin-bottom: 15px;
  }
}
</style>
